module.exports = __webpack_public_path__ + "static/media/skiing-nordic.214d69f2.svg";